import React, { useState, useEffect, useRef } from 'react'
import Field from '../../common/FormField'
import { SERVER } from '../../../constants'

import styles from '../Form.module.css'

function ProfileUrl({
  data,
  error = {},
  disabled,
  onReset,
  onCheckButtonClick,
  validCustomUrl,
  checkingCustomUrl,
  onChangeFactory
}) {
  const [buttonClicked, setButtonClicked] = useState(false)
  const originalPublicLink = useRef(data.publicLink)
  const handlePublicLinkChange = onChangeFactory('publicLink')

  useEffect(() => {
    onReset()
  }, [onReset])

  const handlePublicLinkInput = event => {
    handlePublicLinkChange(event)
    if (buttonClicked) {
      onReset()
      setButtonClicked(false)
    }
  }

  const handleCheckButtonClick = () => {
    onCheckButtonClick(data.publicLink)
    setButtonClicked(true)
  }

  const renderAvailability = () => {
    if (!buttonClicked) return null
    if (checkingCustomUrl) {
      return (
        <div className={styles.availability}>
          <i className="fa fa-spinner fa-pulse fa-fw" />
          <span>Checking...</span>
        </div>
      )
    }
    if (validCustomUrl) {
      return (
        <div className={styles.publicLinkAvailable}>
          Success! {SERVER}/{data.publicLink} is available to take.
        </div>
      )
    }
    return (
      <div className={styles.availability}>
        Sorry, {SERVER}{data.publicLink} is not available, please try another one.
      </div>
    )
  }

  return (
    <fieldset>
      <Field
        type="input"
        name="Choose your custom profile link"
        note="Do not enter any spaces or special characters (i.e. # $ @). Hyphens (-) are allowed."
        error={error.publicLink}
      >
        <div className="input-group">
          <span className="input-group-addon">
            {SERVER}/
          </span>
          <input
            type="text"
            className="form-control"
            value={data.publicLink}
            onChange={handlePublicLinkInput}
            disabled={disabled}
          />
        </div>
      </Field>
      <section>
        <div className={styles.checkAvailability}>
          <button
            type="button"
            className="btn btn-primary btn-lg"
            disabled={disabled || data.publicLink === originalPublicLink.current}
            onClick={handleCheckButtonClick}
          >
            Check Availability
          </button>
          {renderAvailability()}
        </div>
      </section>
    </fieldset>
  )
}

export default ProfileUrl
